import { useTranslation } from "react-i18next";
import Button from '../Button';
import { useState } from "react";

const tabs = [
    {
        subtitle: 'about.history.tab_01.subtitle',
        desc: 'about.history.tab_01.desc',
    },
    {
        subtitle: 'about.history.tab_02.subtitle',
        desc: 'about.history.tab_02.desc',
    },
    {
        subtitle: 'about.history.tab_03.subtitle',
        desc: 'about.history.tab_03.desc',
    },
    {
        subtitle: 'about.history.tab_04.subtitle',
        desc: 'about.history.tab_04.desc',
    },
    {
        subtitle: 'about.history.tab_05.subtitle',
        desc: 'about.history.tab_05.desc',
    },
    {
        subtitle: 'about.history.tab_06.subtitle',
        desc: 'about.history.tab_06.desc',
    },
    {
        subtitle: 'about.history.tab_07.subtitle',
        desc: 'about.history.tab_07.desc',
    },
        {
        subtitle: 'about.history.tab_08.subtitle',
        desc: 'about.history.tab_08.desc',
    },
        {
        subtitle: 'about.history.tab_09.subtitle',
        desc: 'about.history.tab_09.desc',
    },
];

const History = () => {
    const { t } = useTranslation();
    const [active, setActive] = useState(0);

    const setTab = value => active === value
        ? setActive(-1)
        : setActive(value);

    return (
        <section className="relative open-sans pt-[90px] xl:pt-[160px]">
            <div className="relative z-10 max-w-[1220px] xl:mx-auto mx-[20px]">
                <div className="md:grid flex flex-col grid-cols-2 gap-[35px] md:gap-[40px] xl:gap-[95px]">
                    <div>
                        <h2 className="text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                            {t('about.history.title')}
                        </h2>
                        <p className="mt-[25px] md:mt-[30px] max-w-[100%] md:max-w-[561px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                            {t('about.history.text_01')}
                        </p>
                        <p className="mt-[13px] md:mt-[15px] max-w-[100%] md:max-w-[561px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                            {t('about.history.text_02')}
                        </p>
                        <div className="hidden md:flex">
                            <Button className="mt-[40px]" color="#15318D" text="#EFEFEF" />
                        </div>
                    </div>
                    <div className="flex flex-col gap-[8px]">
                        {tabs.map((tab, index) =>
                            <div
                                key={index}
                                onClick={() => setTab(index)}
                                className="flex flex-col border-[1px] border-[#0C2780] py-[12px] lg:py-[15px] sm:px-[20px] px-[10px] cursor-pointer"
                            >
                                <div className="flex gap-[15px] items-center justify-between">
                                    <h4 className="xl:w-[339px] lg:w-[280px] font-[600] open-sans sm:text-[19px] text-[14px] text-[#0C2780] select-none">
                                        {t(tab.subtitle)}
                                    </h4>
                                    <div className="w-[16px] h-[16px] relative flex-shrink-0">
                                        <span className="absolute w-[100%] h-[2px] bg-[#0C2780] left-0 top-[50%] -translate-y-[50%]"></span>
                                        <span className={`absolute w-[100%] h-[2px] bg-[#0C2780] left-0 top-[50%] -translate-y-[50%] ${index === active ? 'rotate-0' : 'rotate-90'} duration-200`}></span>
                                    </div>
                                </div>
                                <div className={`${index === active ? 'flex' : 'hidden'} w-auto font-[300] open-sans sm:text-[16px] text-[14px] text-[#0C2780] mt-[15px]`}>
                                    <p className="">
                                        {t(tab.desc)}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    )
};

export default History;
